'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function Component($http, AppConstants) {
	'ngInject';

	var service = {
		fetchDiscount: fetchDiscount,
		fetchDiscounts: fetchDiscounts,
		getDiscounts: getDiscounts,
		getDiscount: getDiscount,
		createDiscount: createDiscount,
		updateDiscount: updateDiscount,
		deleteDiscount: deleteDiscount
	};

	var discounts = [];
	var discount = {};

	return service;

	function fetchDiscounts() {
		var sort = arguments.length <= 0 || arguments[0] === undefined ? '-id' : arguments[0];

		return $http.get(AppConstants.apiUrl + '/discounts', {
			'params': { sort: sort }
		}).then(setDiscounts)['catch'](failedRequest);
	}

	function fetchDiscount(id) {
		var relations = arguments.length <= 1 || arguments[1] === undefined ? 'translations' : arguments[1];

		return $http.get(AppConstants.apiUrl + '/discounts/' + id, {
			'params': {
				'with': relations
			}
		}).then(setDiscount)['catch'](failedRequest);
	}

	function setDiscounts(response) {
		discounts = response.data.data;

		return discounts;
	}

	function setDiscount(response) {
		discount = response.data.data;

		return discount;
	}

	function getDiscounts() {
		return discounts;
	}

	function getDiscount() {
		return discount;
	}

	function createDiscount(params) {
		return $http.post(AppConstants.apiUrl + '/discounts', params).then(successRequest)['catch'](failedRequest);
	}

	function updateDiscount(id, params) {
		return $http.put(AppConstants.apiUrl + '/discounts/' + id, params).then(successRequest)['catch'](failedRequest);
	}

	function deleteDiscount(id) {
		return $http['delete'](AppConstants.apiUrl + '/discounts/' + id).then(successRequest)['catch'](failedRequest);
	}

	function successRequest(response) {
		return response;
	}

	function failedRequest(requestError) {
		console.log(requestError);
		return requestError;
	}
}

exports['default'] = Component;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/discount/discount.service.js
 **/